export default __webpack_public_path__ + "static/customnotifications-1ca0d5300a36aa4e2f5f29eb3bde9176.svg";